module.exports = ".title-magazine h3 {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/publication-view/publication-thumbnail/publication-thumbnail.component.scss
// module id = ./src/app/shared/publication-view/publication-thumbnail/publication-thumbnail.component.scss
// module chunks = main